import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MiscRelayOutputGlyph = /*#__PURE__*/createElement("g", {
  id: "misc_relay_output"
}, /*#__PURE__*/createElement("path", {
  d: "M54.08 55.93H29.92c-7.44 0-13.5-6.06-13.5-13.5v-.85c0-7.44 6.06-13.5 13.5-13.5h24.17c7.44 0 13.5 6.06 13.5 13.5v.85c-.01 7.44-6.06 13.5-13.51 13.5zM29.92 31.07c-5.79 0-10.5 4.71-10.5 10.5v.85c0 5.79 4.71 10.5 10.5 10.5h24.17c5.79 0 10.5-4.71 10.5-10.5v-.85c0-5.79-4.71-10.5-10.5-10.5H29.92z"
}), /*#__PURE__*/createElement("path", {
  d: "M31 43.5H15.92c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5H31c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm37.08 0H53c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h15.09c.83 0 1.5.67 1.5 1.5s-.68 1.5-1.51 1.5zm-33.46-.67c-.74 0-1.45-.41-1.79-1.11-.49-.99-.08-2.19.91-2.68l12.71-6.28a2.002 2.002 0 011.77 3.59L35.5 42.62c-.28.14-.59.21-.88.21z"
}), /*#__PURE__*/createElement("circle", {
  cx: 32.28,
  cy: 42,
  r: 3.45
}), /*#__PURE__*/createElement("circle", {
  cx: 51.86,
  cy: 42,
  r: 3.45
}));
const MiscRelayOutput = createSvg({
  name: 'misc_relay_output',
  path: MiscRelayOutputGlyph
});

export default MiscRelayOutput;
export { MiscRelayOutputGlyph };
